import { render, staticRenderFns } from "./BoardDialog.vue?vue&type=template&id=b7af1fb0&"
import script from "./BoardDialog.vue?vue&type=script&lang=js&"
export * from "./BoardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports